module.exports = __webpack_public_path__ + "img/delete.90b7ce9f.svg";